import { SourceObjectTypeEnum } from "../../enums/accounting/source-object-type-enum";
import { TargetObjectTypeEnum } from "../../enums/accounting/target-object-type-enum";
import { BaseModel } from "../base.model";

export class AccountingObjectMappingModel extends BaseModel{
    sourceObjectType?: SourceObjectTypeEnum;
    sourceId?: string;
    sourceName?: string;

    targetObjectType?: TargetObjectTypeEnum;
    targetId?: string;
    targetName?: string;

    enableInLineEditing?: number = 0;

    description?: string; 

    constructor(sourceObjectType: SourceObjectTypeEnum, sourceId: string, sourceName: string, targetObjectType: TargetObjectTypeEnum, targetId: string, targetName: string) {
        super();
        this.sourceObjectType = sourceObjectType;
        this.sourceId = sourceId;
        this.sourceName = sourceName;
        this.targetObjectType = targetObjectType;
        this.targetId = targetId;
        this.targetName = targetName;
    }
}